import React from "react";

// Model Layout Component - CareEconomy
const playBounce = (event, state) => {
  const el = event.currentTarget;
  el.classList.remove("map-hover-enter", "map-hover-leave");
  void el.offsetWidth;
  el.classList.add(state);
};

const bounceHandlers = {
  onMouseEnter: (e) => playBounce(e, "map-hover-enter"),
  onMouseLeave: (e) => playBounce(e, "map-hover-leave"),
};

const careLayers = [
  {
    id: "ce0",
    src: "/assets/svgs/care-economy-svgs/ce0.svg",
    alt: "Core connectors",
    style: { left: "19%", top: "37%" },
  },
  {
    id: "ce1",
    src: "/assets/svgs/care-economy-svgs/ce1.svg",
    alt: "Roadblocks to sustainable care economy",
    style: { left: "6%", top: "20%" },
    tooltip: "Care Economy x Gender",
    // tooltipPlacement: "top-bottom",
  },
  {
    id: "ce2",
    src: "/assets/svgs/care-economy-svgs/ce2.svg",
    alt: "Care priorities",
    style: { left: "9.5%", top: "54%" },
  },
  {
    id: "ce3",
    src: "/assets/svgs/care-economy-svgs/ce3.svg",
    alt: "ILO’s 5R framework for decent care work",
    style: { left: "32%", top: "43%", zIndex: 50 },
  },
  {
    id: "ce4",
    src: "/assets/svgs/care-economy-svgs/ce4.svg",
    alt: "World Economic Forum perspective",
    style: { left: "38%", top: "23%", zIndex: 40 },
  },
  {
    id: "ce5",
    src: "/assets/svgs/care-economy-svgs/ce5.svg",
    alt: "Value of women’s unpaid work",
    style: { left: "66%", top: "35%", zIndex: 50 },
  },
  {
    id: "ce6",
    src: "/assets/svgs/care-economy-svgs/ce6.svg",
    alt: "Projections by age group",
    style: { left: "79%", top: "50%", zIndex: 40 },
    tooltip: "Care Economy x Gender",
    tooltipPlacement: "top",
  },
  {
    id: "ce7",
    src: "/assets/svgs/care-economy-svgs/ce7.svg",
    alt: "Zoom in and read more controls",
    style: { left: "75.4%", top: "85.8%" },
    tooltip: "Care Economy x Gender",
  },
  {
    id: "ce8",
    src: "/assets/svgs/care-economy-svgs/ce8.svg",
    alt: "Impact on children",
    style: { left: "54%", top: "95.8%" },
    tooltip: "Care Economy x Gender",
    tooltipPlacement: "bottom",
  },
  {
    id: "ce9",
    src: "/assets/svgs/care-economy-svgs/ce9.svg",
    alt: "Non-paid care arrangements",
    style: { left: "32%", top: "80%" },
    tooltip: "Care Economy x Gender",
    tooltipPlacement: "right",
  },
  {
    id: "ce10",
    src: "/assets/svgs/care-economy-svgs/ce10.svg",
    alt: "Care economy layered stack",
    style: { left: "53%", top: "65%" },
  },
];

const CareEconomyModel = ({ className = "", showTooltips = true }) => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const getScrollTarget = (layerId) => {
    const scrollMap = {
      ce1: "global-roadmap-care-economy",
      ce2: "care-economy-scenarios",
      ce3: "strong-care-economy",
      ce4: "wef-care-economy",
      ce5: "what-is-care-economy",
      ce6: "care-economy-india",
      ce7: "care-economy-indonesia",
      ce8: "care-economy-nepal",
      ce9: "care-economy-bangladesh",
    };
    return scrollMap[layerId];
  };

  return (
    <main className="relative pt-5">
      <section className="p-2">
        <div
          className={`relative mx-auto aspect-[1070/865] max-w-[1100px] ${className}`}
        >
          {careLayers.map((layer) => {
            const interactive = layer.id !== "ce10" && layer.id !== "ce0";
            const hoverTiming = {
              "--map-seq-name": "mapSeqReveal",
              "--map-seq-duration": "1200ms",
              "--map-seq-delay": "0ms",
            };

            const tooltipPos = (() => {
              switch (layer.tooltipPlacement) {
                case "left":
                  return "left-full top-1/2 -translate-y-1/2 ml-2";
                case "right":
                  return "right-full top-1/2 -translate-y-1/2 mr-2";
                case "top":
                  return "bottom-full left-1/2 -translate-x-1/2 left-[70%] mb-5";
                case "bottom":
                  return "top-full left-[57%] -translate-x-1/2 mt-2";
                default:
                  return "top-full left-1/2 -translate-x-1/2 mt-2";
              }
            })();

            const scrollTarget = getScrollTarget(layer.id);
            const handleClick = scrollTarget
              ? () => scrollToSection(scrollTarget)
              : undefined;

            return (
              <div
                key={layer.id}
                className={`absolute -translate-x-1/2 -translate-y-1/2 ${interactive ? "group" : ""
                  }`}
                style={layer.style}
              >
                <div className="relative">
                  <img
                    src={layer.src}
                    alt={layer.alt}
                    loading="lazy"
                    className={`select-none max-w-max object-contain ${interactive
                        ? "map-hover-bounce hover:cursor-pointer pointer-events-auto map-seq"
                        : "pointer-events-none"
                      }`}
                    style={interactive ? { ...hoverTiming } : undefined}
                    {...(interactive ? bounceHandlers : {})}
                    {...(handleClick ? { onClick: handleClick } : {})}
                  />
                  {interactive && layer.tooltip && showTooltips && (
                    <span
                      className={`pointer-events-none z-50 absolute rounded-md bg-[#FEFBF6] p-2 text-[11px] font-normal text-black text-nowrap opacity-0 transition-opacity duration-200 group-hover:opacity-100 ${tooltipPos}`}
                    >
                      {layer.tooltip}
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </main>
  );
};

export default CareEconomyModel;
